export type GetNameArgs = {
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    preferredFirstName?: string | null;
    preferredName?: string | null;
};

export type GetNameOptions = {
    abbreviateLastName?: boolean;
};

export default function (args: GetNameArgs, options: GetNameOptions = {}): string {
    const lastName = options.abbreviateLastName ? args.lastName?.charAt(0) : args.lastName;
    const firstName = args.preferredName || args.preferredFirstName || args.firstName;

    return [firstName, args.middleName, lastName].filter(Boolean).join(' ') || '';
}
